const mainbgChatColorsByThemes = {
  "american-2": "#032952",
  "american-3": "#032952",
  american: "#c80505",
  classic: "#f96400",
  godos: "#46528b",
  gov: "#c1a783",
  "green-navy": "#009990",
  "light-blue-navy": "#00b9ff",
  navy: "#0a8bfe",
  purple: "#46528b",
  vital: "#46528b",
};

const scriptConfigurations = (currentUrl, theme) => {
  const mainbgChatColor = mainbgChatColorsByThemes[theme];
  return `window.prechatTemplate = {
    SubmitLabel: "Start Chat",
    fields: {
      1: {
        error: "Please Enter a valid name",
        fieldId: "name",
        label: "Name",
        required: "yes",
        type: "text",
      },
      2: {
        error: "Please Enter a valid Email",
        fieldId: "email",
        label: "Email",
        required: "yes",
        type: "email",
      },
    },
    heading: "Chat with Us",
    "mainbgColor": "${mainbgChatColor}",
    "maintxColor": "#fff",
    textBanner:
      "We can't wait to talk to you. But first, please take a couple of moments to tell us a bit about yourself.",
  };
  window.fcSettings = {
    onInit: function () {
      window.fcWidget.on("widget:loaded", function() {
        window.fcPreChatform.fcWidgetInit(window.prechatTemplate);

        window.fcWidget.conversation.setConversationProperties({
          cf_customer_url: "${currentUrl}"
        });
      });
    },
  };
  window.fcWidgetMessengerConfig = {
    config: {
      content: {
        actions: {
          tab_chat: "Chat",
        },
        headers: {
          chat: "Chat With Us",
        },
      },
      cssNames: {
        expanded: "custom_fc_expanded",
        widget: "custom_fc_frame",
      },
    },
  };
`;
};

export default scriptConfigurations;
